import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { useAssets } from "../assets/AssetsContext";
import { Link } from "react-router-dom";

function AccelSupply() {
  const assets = useAssets();

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: false,
    });
    AOS.refresh();
  }, []);
  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };
  const corecapabilities = [
    {
      title: "Multi-Tier Supplier Mapping & Relationship Graphs",
      description: "",
      img: assets.accelsupply_cc1,
    },
    {
      title: "ESG & Human Rights Due Diligence (HRDD) Tracking",
      description: "",
      img: assets.accelsupply_cc2,
    },
    {
      title: "Regulatory Readiness",
      description: "(EUDR, CSRD, CBAM, BRSR Core)",
      img: assets.accelsupply_cc3,
    },
    {
      title: "Supplier Sustainability Scorecards & Ratings",
      description: "",
      img: assets.accelsupply_cc4,
    },
    {
      title: "Traceability to Origin: Materials, Emissions, Labor Practices",
      description: "",
      img: assets.accelsupply_cc5,
    },
    {
      title: "Scope 3 Emissions Estimation by Category",
      description: "(Purchased Goods, Logistics, etc.)",
      img: assets.accelsupply_cc6,
    },
    {
      title: "AI-Powered Risk Detection",
      description: "(Deforestation, Forced Labor, Conflict Zones)",
      img: assets.accelsupply_cc7,
    },
  ];

  return (
    <div>
      <div className="inner-new-section-1 accelsupply-bg-1">
        <div className="wrapper height-inherit">
          <div className="bottom-sec-1 max-width-500 padding-bottom-1">
            {/* <img
              src={assets.AccelSupplyLogo2}
              alt="AccelALERT"
              data-aos="fade-down"
            /> */}
            <h1 className="white-color" data-aos="fade-up">
              AccelSUPPLY+<sup>™</sup> – The Sustainable Supply Chain
              Intelligence Platform
            </h1>
            <p data-aos="zoom-in">
              End-to-end visibility, risk assessment, and sustainability
              tracking for responsible sourcing and ESG-aligned operations.
            </p>
            <div className="text-left">
              <Link
                to="/company/contact#Book-Meeting"
                className="button-1 light-green-bg"
                data-aos="fade-down"
              >
                Request a Demo
              </Link>
            </div>
          </div>
        </div>
      </div>
      <div className="inner-new-section-1 accelsupply-bg-2">
        <div className="wrapper height-inherit">
          <div className="flagship-heading">
            <h2 className="light-green-color">
              Built for Resilient, Transparent & Ethical Supply Chains
            </h2>
          </div>

          <div className="section-2-2">
            <p>
              AccelSUPPLY+ helps organizations gain full-spectrum visibility
              into their supply chains—measuring ESG risk, regulatory exposure,
              and supplier sustainability performance. From procurement to
              last-mile delivery, it enables traceability, due diligence, and
              climate-smart decisions across Tier 1 to Tier N suppliers.
            </p>
          </div>
        </div>
      </div>
      <div className="inner-new-section-1 accelalert-bg-3">
        <div className="wrapper">
          <div className="flagship-heading">
            <h2 className="text-center light-green-color">Core Capabilities</h2>
          </div>

          <div className="Core-Capabilities-wrap">
            <div className="Core-Capabilities-wrap">
              {corecapabilities.map((corecapabilities, index) => (
                <div className="cc-1" key={index}>
                  <div className="cc-1-1">
                    <img src={corecapabilities.img} alt="" data-aos="zoom-in" />
                  </div>
                  <div className="cc-1-2" data-aos="zoom-in">
                    <h6>{corecapabilities.title}</h6>
                    {corecapabilities.description && (
                      <p>{corecapabilities.description}</p>
                    )}
                  </div>
                </div>
              ))}
            </div>
            {/* <img
              src={assets.GlobalStandards}
              alt="GlobalStandards"
              className="w-100"
            /> */}
          </div>
        </div>
      </div>

      <div className="inner-new-section-1 accelalert-bg-3">
        <div className="wrapper">
          <div className="flagship-heading">
            <h2 className="text-center light-green-color" data-aos="fade-up">
              Designed for Compliance with Global Standards
            </h2>
            <p>Accelerating alignment with:</p>
          </div>

          <div className="Core-Capabilities-wrap">
            {/* <div className="Core-Capabilities-wrap">
              {corecapabilities.map((corecapabilities, index) => (
                <div className="cc-1" key={index}>
                  <div className="cc-1-1">
                    <img src={corecapabilities.img} alt="" />
                  </div>
                  <div className="cc-1-2">
                    <h6>{corecapabilities.title}</h6>
                    {corecapabilities.description && (
                      <p>{corecapabilities.description}</p>
                    )}
                  </div>
                </div>
              ))}
            </div> */}
            <img
              src={assets.GlobalStandards}
              alt="GlobalStandards"
              className="w-100"
              data-aos="zoom-in"
            />
          </div>
        </div>
      </div>

      <div className="inner-new-section-1 accelsupply-bg-3">
        <div className="wrapper height-inherit">
          <h2>One Platform, Total Visibility</h2>

          <div className="section-2-2 flex-column">
            <div className="SituationalIntelligence flex-end">
              <div className="black-bg-2">
                <p>
                  “AccelSUPPLY+™ gave us control over what used to be a black
                  box. Now, we have full clarity on where our emissions and ESG
                  risks are coming from.”
                </p>
                <i>— Chief Procurement Officer, Consumer Goods Company</i>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="inner-new-section-1 accelalert-bg-4a">
        <div className="wrapper height-inherit">
          <div className="flagship-heading">
            <h2>Integrates with Sensors, Satellites, and Systems</h2>
          </div>
          <div className="text-center">
            <img
              src={assets.IntegrationsIntelligence}
              alt="AccelALERt2"
              className="img-w-1"
            />
          </div>
        </div>
      </div>
      <div className="inner-new-section-1 accelalert-bg-4b">
        <div className="wrapper height-inherit">
          <div className="bioforge-section-2-1">
            <h2 className="white-color text-left">
              Powerful Dashboards & Scorecards
            </h2>
          </div>
          <div className="bioforge-align-left ">
            <div className="bioforge-section-2-2">
              <div className="building-list">
                <ul>
                  <li>Risk-Weighted Supplier Performance</li>
                  <li>Material Impact Scoring (Water, Emissions, Labor)</li>
                  <li>Procurement ESG Heatmaps</li>
                  <li>Custom Watchlists for High-Risk Suppliers</li>
                  <li>Automated alerts and supplier engagement workflows</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="ClimateFutureTogether-bg">
        <div className="wrapper">
          <div className="flagship-heading">
            <h2 className="blue-color">
              Ready to Build a Sustainable Supply Chain?
            </h2>
            <p>
              Get in touch to explore how AccelSUPPLY+™ can transform your
              procurement ecosystem.
            </p>

            <Link
              to="/company/contact#Book-Meeting"
              className="button-1 light-green-bg"
              onClick={scrollToTop}
            >
              Book a Live Demo
            </Link>
            <Link
              to="/company/contact#Book-Meeting"
              className="button-1"
              onClick={scrollToTop}
            >
              Talk to Our Experts
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AccelSupply;
